//Componente importado de material ui
import { createMuiTheme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
//Estilo genérico importado
import { estilosTextosPrincipales, colores, tipografia, backgroundRectangle, buttonPrimaryBig, buttonSecundaryBig } from '../../../AppStyle';
/**
 * Clases de material ui sobreescritas
 */

//Sobreescritura de las clases de material aplicadas a helperText
export const overInputs = createMuiTheme({
    overrides: {
        MuiFormHelperText: {//Clases aplicadas en los helpTexts
            root: {
                ...estilosTextosPrincipales.body2,
                color: colores.estado.error,
                fontSize: '12px',
                width: "328px",
            },
            contained: {
                marginLeft: '0px',
                marginRight: '0px',
            }
        },
        MuiInputBase: {//Clases aplicadas en los inputs
            root: {
                height: '48px',
                width: '328px',
                '&$disabled': {//Clase aplicada cuando el input está deshabilitado                    
                    backgroundColor: colores.escalaGrises.contenedor,        
                },
            },
            input: {
                ...estilosTextosPrincipales.body2,
                fontSize: '14px',
                //lineHeight: '24px',
                letterSpacing: '0px',
                color: colores.escalaGrises.cien,
                '&::placeholder': {
                    ...estilosTextosPrincipales.body2,
                    fontSize: '14px',
                    //lineHeight: '24px',
                    letterSpacing: '0px',
                    opacity: '0.8',
                    color: colores.escalaGrises.apoyo,
                },
            },
        },
        MuiOutlinedInput: {//Clases aplicadas a los bordes de los inputs
            root: {
                '&:hover $notchedOutline': {
                    border: '2px',
                    borderStyle: 'solid',
                    borderColor: colores.principales.principal
                },
                '&$focused $notchedOutline': {
                    border: '2px',
                    borderStyle: 'solid',
                    borderColor: colores.principales.principal
                },
            },
            notchedOutline: {
                border: '1px solid',
                borderColor: colores.principales.apoyo,
                boxSizing: 'border-box',
                borderRadius: '4px',
            },
        },
        MuiInputLabel: {//Evita que se reduzca el título
            shrink: {
                transform: 'none'
            },
        }
    },
});
/**
 * Classes creadas para aplicar a los componentes
 */

export default makeStyles({
    ///////////////////////////////TITULOS
    classEncabezadoH1: {
        ...estilosTextosPrincipales.encabezadoH1,
        color: colores.escalaGrises.cien,
        fontWeight: '300',
        letterSpacing: '0',
    },
    classEncabezadoH2: {
        ...estilosTextosPrincipales.encabezadoH2,
        color: colores.escalaGrises.cien,
        letterSpacing: '0',
        lineHeight: '35px',
        width: '100%',
        marginTop: '2%'
    },
    classEncabezadoH3: {
        ...estilosTextosPrincipales.encabezadoH3,
        color: colores.escalaGrises.cien,
        letterSpacing: '0',
        lineHeight: '35px',
        width: '100%',
        marginTop: '2%'
    }, 
    classParrafo: {
        ...estilosTextosPrincipales.body2,
        color: colores.escalaGrises.noventa,
        letterSpacing: '0',
        lineHeight: '19px',
    },
    ///////////////////////////////GRIDS
    classGrid: { 
        marginTop: '15px',
        marginBottom: '15px',
        marginRight: '20px',
        width: 'auto',
        textAlign: 'left',
        display: 'block',
    },
    classGridAlert:{
        marginTop: '15px',
        marginBottom: '15px',
        width: 'auto',
        textAlign: 'left',
        display: 'block',
    },
    classGridEncabezado: {
        width: '90%',
        marginTop: '19.51px',
        marginBottom: '32px',
        marginLeft: '5%',
        marginRight: '5%'
    },
    classGridDatos: {
        width: 'auto',
        padding: '5%',
        paddingBottom: '0',
        paddingTop: '0',
    },
    classGridButtons: {
        width: 'auto',
        marginLeft: '4.5%',
        marginRight:'4.5%',
        marginBottom: '2%'
    },
    ///////////////////////////////CONTAINERS
    classContaFormLoginAdministrador: {
        width: '1170px',
        height: 'auto',
    },
    classContaComponentes: {
        ...backgroundRectangle,
    },
    ///////////////////////////////LINEAS SEPARATORIAS
    classLine: {
        boxSizing: 'borderBox',
        height: '1px',
        width: '100%',
        border: '1px',
        borderStyle: 'solid',
        borderColor: '#D5D4D4',
        marginTop: '15px',
        marginBottom: '15px',
    },
    ///////////////////////////////InputLabel
    classInputLabel: {
        ...estilosTextosPrincipales.body2,
        fontFamily: tipografia.regular,
        color: colores.escalaGrises.ochenta,
        fontSize: '12px',
        fontWeight: 'bold',
        letterSpacing: '0',
        lineHeight: ' 17px',
        marginBottom: '5px',
        position: 'relative',
        '&.Mui-focused': {
            color: '#555555',
        },
    },
    ///////////////////////////////BOTON
    classButton: {
        ...buttonPrimaryBig,
        width: '141px',
    },
    classButtonCancelar: {
        ...buttonSecundaryBig,
        width: '141px',
    },
    ///////////////////////////////BACKDROP
    classBackdrop: {
        zIndex: 1,
        color: '#fff',
    },
    classIcon: {
        color: colores.escalaGrises.cien
    },
    classSpanRequired: {
        color: colores.principales.required,
        ...estilosTextosPrincipales.body2,
    }
});